<template>
  <div
    class="diagnostic"
    id="section-diagnostics"
  >
    <div v-if="diagnosticReports.length" class="width100">
      <div
        id="open-sidebar-btn"
        class="open-sidebar-btn cursor-pointer"
        @click="isShow.sidebar = true"
      ></div>
      <diagnostics-sidebar
        id="section-diagnostics-sidebar"
        :class="[{ 'sidebar-active': isShow.sidebar }]"
        :reports="diagnosticReports"
        @show="changeDisplaySections"
      />
    </div>
    <div
      v-else
      class="diagnostics__no-rights"
      id="section-diagnostics"
    >
      Раздел не подключен, обратитесь к поставщику услуг
    </div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch, inject } from 'vue';
import DiagnosticsSidebar from './Sidebar/DiagnosticsSidebar.vue';

import { fuelSettingsStore } from '@/App/store/FuelSettingsStore';

const props = defineProps({
  openWindow: { type: String, required: true },
  clientWidth: { type: Number, required: true },
});
const emit = defineEmits(['ready', 'update:open-window']);

const userData = inject('userData');

const diagnosticReports = ref([]);

const isShow = ref({
  sidebar: true,
  map: true,
});

onMounted(async () => {
  diagnosticReports.value = getDiagnosticRights(userData);

  await nextTick();

  fuelSettingsStore.runUpdating();

});

watch(
  isShow,
  (show, oldShow) => {
    const sidebarNode = document.getElementById('section-diagnostics-sidebar');
    const openBtnNode = document.getElementById('open-sidebar-btn');

    if (!sidebarNode) return;

    if (openBtnNode) openBtnNode.classList.remove('active');

    if (show.sidebar && show.map) {
      sidebarNode.style.width = '420px';
    }
    if (show.sidebar && !show.map) {
      sidebarNode.style.width = '100%';
    }

    if (!show.sidebar && show.map) {
      openBtnNode.classList.add('active');
    }

    if (!show.sidebar && !show.map) {
      isShow.value.sidebar = !oldShow.sidebar;
      isShow.value.map = !oldShow.map;
    }
  },
  { deep: true },
);

watch(
  () => userData,
  (newUserData, oldUserData) => {
    diagnosticReports.value = getDiagnosticRights(newUserData);
  },
  { deep: true },
);

const getDiagnosticRights = (newUserData) => {
  const templateNamesAvailable =
    newUserData?.senderRights?.templates_names_available_arr || {};
  const reports = [];
  for (const reportName in templateNamesAvailable) {
    if (templateNamesAvailable[reportName]) {
      reports.push(reportName);
    }
  }
  return reports;
};

const changeDisplaySections = async (name) => {
  if (!name) return;

  isShow.value[name] = !isShow.value[name];

  await new Promise((r) => setTimeout(r, 300));
};
</script>

<style lang="scss" scoped>
.diagnostics {
  &__no-rights {
    padding: 10px;
  }
}
.open-sidebar-btn {
  width: 80px;
  height: 80px;

  position: fixed;
  top: 50%;
  left: -80px;
  z-index: 500;

  transform: translateY(-50%);

  background: var(--blue);
  border-radius: 50%;

  transition: all 0.2s ease;

  &.active {
    left: -40px;

    &:hover {
      -webkit-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
      -moz-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
      box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
    }
  }

  &::before {
    content: ' ';
    position: absolute;
    top: 50%;
    right: 20px;
    z-index: 11;
    width: 20px;
    height: 20px;
    transform: translateY(-50%) rotate(45deg);
    border-top: 2px solid #fff;
    border-right: 2px solid #fff;
  }
}
#section-diagnostics {
  overflow: hidden;
  @media (max-width: 450px) {
    display: flex;
  }
}
#section-diagnostics-sidebar {
  padding: 0;
  flex-direction: column;

  margin-left: -420px;

  transition: all 0.3s ease-in-out;
  &.sidebar-active {
    margin-left: 0;
  }

  @media (max-width: 768px) {
    width: 100%;
  }

  @media (max-width: 450px) {
    display: block;
  }
}
.diagnostic {
  margin: 0;

  &__map {
    height: calc(100vh - 70px);
    width: 100%;

    @media (max-width: 1070px) {
      height: calc(100vh - 86px);
    }

    @media (max-width: 768px) {
      height: calc(100vh - 70px);
    }

    @media (max-width: 575px) {
      height: calc(100vh - 91px);
    }
  }
}
.width100 {
  @media (max-width: 768px) {
    width: 100%;
  }
}
</style>
